import { render, staticRenderFns } from "./OHtmlArea.vue?vue&type=template&id=b5dbcd32&scoped=true&"
import script from "./OHtmlArea.vue?vue&type=script&lang=js&"
export * from "./OHtmlArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dbcd32",
  null
  
)

export default component.exports